import styled from 'styled-components'

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
    display: grid;
    width: 500px;
  }
`
export const UserDataContainer = styled.div`

    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top:40px;

`



// >>>>>>>>>>>CONTAINER DIREITO<<<<<<<<<<


export const UserDataRightContainer = styled.div`
    border: 3px solid #7e7d7a;
    width: 100%;
    height: 35%;
    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius:15px;

    @media (max-width: 768px) {
    /* width: 100%; */
  }
`
export const UserDataTitle = styled.div`

    border-bottom: 2px solid #7e7d7a;
    display: flex;
    flex-direction:row;
    align-items: center;
    margin: 20px;
    color: #002666;
    font-size: 26px;
    margin-bottom:6px;
    margin-top: 60px;
    i{
        font-size:60px;
        margin-right: 20px;
    }

`
export const UserDataSubTitle = styled.div`


    font-style:bold;
    font-size: 20px;
    margin: 10px;
    margin-left: 20px;
    color: #002666;
`
export const UserAccountData = styled.div`


        display:flex;
        flex-direction:column;
        margin:20px;




    .user-name-email{
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        background:#dfdede;
        border-radius:8px;
        height: 80px;
        padding:5px 10px;
        margin-right: 30px
        i{
        font-size:20px;
        }

    }
    .user-name{

        display:flex;
        flex-direction:row;
        justify-content:space-between;
        margin: 0px 30px 0px 30px;
        i{
        font-size:20px;
        }

    }
    .user-email{
        display:flex;
        flex-direction:row;
        justify-content:space-between;
        margin: 0px 30px 0px 30px;
        padding-top: 7px;
        border-top: solid 1px;
        i{
        font-size:20px;
        }
    }

    .alert-nfe{
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    margin-top:10px;

    background:#80a3c7;
    border-radius:8px;
    padding:10px 40px;

        i{
            color:red;
            font-size:20px;
            justify-content:center;
        }
    }

`

export const UserPersonalData = styled.div`
        display:flex;
        flex-direction:column;
        margin:10px 20px;
        background:#dfdede;
        border-radius:8px;
        padding:10px 40px;



    .user-data-row{
        display:flex;
        flex-direction:row;
        justify-content:space-between;
        border-bottom: 1px black solid;
        padding: 7px 0px 7px 0px;

        i{
        font-size:20px;
        }

    }


`

export const UserCreditCard = styled.div`

        display:flex;
        flex-direction:column;
        background:#dfdede;
        border-radius:8px;
        padding:2px 10px;
        margin:20px;


.credit-card-info-container{
        display:flex;
        flex-direction:row;
        justify-content:left;
        border-radius:8px;
        padding:2px 10px;
        align-items:center;


 i{
    font-size:45px;
    border-radius:50%;
    border:solid 2px;
    display:flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
 }

}

.credit-card-data-container{
    flex:1;
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:left;
    padding:10px 40px;

}

.position-txt-exclude{
    /* display:flex; */
    /* justify-content:center; */
    justify-self:flex-end;
    margin-right:14px;



}

`

export const UserAdress = styled.div`

        display:flex;
        flex-direction:row;
        justify-content:space-between;
        background:#dfdede;
        border-radius:8px;
        padding:2px 10px;
        margin:20px;
        padding:20px;
        color:black;

        i{
            font-size:25px;
            margin:10px 20px;
        }

    .adress-container{
    display:flex;
    flex-direction:column;
    /* border:red solid; */
    .add-adress{
        color: red;
        margin-top:20px;
    }
`